/* eslint no-console:1 */

export default class Clipboard {

  constructor(el) {

    if ( !navigator.clipboard ) {

      return;
    }
    this.el = el;
    this.el.addEventListener('click', this.onClick.bind(this), false);
  }

  onClick(e) {

    e.preventDefault();

    const textToCopy = this.el.textContent;

    navigator.clipboard.writeText(textToCopy)
      .then(() => {
        console.log('Text copied to clipboard:', textToCopy);
      })
      .catch(err => {
        console.error('Failed to copy text to clipboard:', err);
      });
  }
}
